import BaseApi from "@/api/BaseApi";

export default class Competencies extends BaseApi {

    construct() {}

    static async create(payload) {
        return this.post(this.getApiUrl(), payload);
    }

    static async index(filters = {}) {
        return this.get(this.getApiUrl(), filters);
    }

    static async all(filters = {}) {
        return this.index({params: filters});
    }

    static async update(id, payload) {
        return this.patch(`${this.getApiUrl()}/${id}`, payload);
    }

    static async delete(id, payload = {}) {
        return this.getAxiosInstance().delete(`${this.getApiUrl()}/${id}`, {
            data: payload,
        });
    }

    static async show(id) {
        return this.get(`${this.getApiUrl()}/${id}`);
    }
}